export default {
  addedgGrouping: 'Added grouping',
  addMeasurementPoints: 'Add measurement points',
  rename: 'Rename',
  shareGroupings: 'Share groupings',

  deleteAMeasurementPoint: 'Delete a measurement point',
  measurementPointCodeOrMeasurementPointName: 'Measurement point code or measurement point name',
  search: 'Search',
  bulkDeletion: 'Bulk deletion',

  measurementPointName: 'Measurement point name',
  measurementPointCoding: 'Measurement point coding',
  measurementPointShortName: 'Measurement Point Short Name',
  measurementPointType: 'Measurement point type',
  associateTheDevice: 'Associate the device',
  unit: 'Unit',
  measurementPointPeriod: 'Measurement point period (ms)',
  measurementPointDrive: 'Measurement point drive',

  detail: 'Detail',
  addedMeasurementPoints: 'Added measurement points',
  editTheMeasurementPoints: 'Edit the measurement points',
  viewMeasurementPoints: 'View measurement points',
  theListOfMeasurementPointsIsImportedIntoTheTemplate:
    'The list of measurement points is imported into the template.xlsx',
  analogue: 'Analogue',
  switchingAmount: 'Switching amount',
  PleaseSelectTheDataYouWantToDelete: 'Please select the data you want to delete',
  whetherToDeleteTheSelectedData: 'Whether to delete the selected data',
  hint: 'hint',
  confirm: 'Confirm',
  theDeletionWasSuccessful: 'The deletion was successful',
  theDeletionHasBeenCanceled: 'The deletion has been canceled',
  noRecordsAreCurrentlySelected:
    ' No records are currently selected, the system will export all data in the system by default, the operation will take a long time, please confirm whether you want to continue?',
  synchronizationAttention: 'Synchronizing data takes a long time, Please proceed with caution',
  NotCurrentlySelected:
    'If you do not select any records, all the data of the current directory will be exported, this operation will take a long time, please confirm if you want to continue?',
  listOfMeasurementPoints: 'List of measurement points.xlsx',
  pleaseFillInTheMeasuremenPointCode: ' Please fill in the measurement point code',
  pleaseFillInTheNameOfTheMeasurementPoint: 'Please fill in the name of the measurement point',
  pleaseFillInTheUnit: 'Please fill in the unit',
  shortName: 'abbreviation',
  PleaseFillInShortName: 'Please fill in the abbreviation',
  measurementPointPeriodMs: 'Measurement point period',
  pleaseFillinTheMeasurementPointPeriod: 'Please fill in the measurement point period',
  expression: 'Expression',
  pleaseFillInTheExpression: 'Please fill in the expression',
  maximumRange: 'Maximum range',
  pleaseFillInTheUpperMileageLimit: 'Please fill in the upper mileage limit',
  lowerRange: 'Lower range',
  pleaseFillInTheLowerMeasuringRange: 'Please fill in the lower measuring range',
  save: 'Save',
  pleaseEnterAnIntegerGreaterThan: 'Please enter an integer greater than 0',
  saveSuccessfully: 'Save successfully',
  cancel: 'Cancel',
}
